import { format, eachDay, isBefore, isEqual, isAfter, isToday } from 'date-fns';
export function dateToString(date, dateFormat = 'D MMMM YYYY', options = { locale: 'en' }) {
    const formatOptions = Object.assign({}, options, { locale: getLocale(options.locale) });
    return format(date, dateFormat, formatOptions);
}
export function getLocale(expectedLocale) {
    // MY and VN dont have translation locale yet, we use en for those  country https://date-fns.org/docs/I18n
    const locale = {
        id: require('date-fns/locale/id'),
        ph: require('date-fns/locale/fil'),
        th: require('date-fns/locale/th'),
        en: require('date-fns/locale/en'),
    };
    switch (expectedLocale) {
        case 'id':
            return locale.id;
        case 'ph':
            return locale.ph;
        case 'th':
            return locale.th;
        default:
            return locale.en;
    }
}
export default {
    dateToString,
    getLocale,
    eachDay,
    isBefore,
    isEqual,
    isAfter,
    isToday,
};
